import { Form, FormRenderer } from "../MDDForm/MDDForm.jsx";
import {
  ContentDialog,
  ContentDialogInit,
} from "components/MDDForm/components/ContentDialog.jsx";
import { getRWObjectCopy } from "../MDDForm/helper.js";
import { fdefSchadenEdit } from "formdefs/schaden_edit.js";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { backendDataAtom } from "recoil/atoms/backendDataAtom.js";

import { useClaimActions } from '../../hooks/useClaimActions.jsx';

ClaimDataFormModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  claim_id: PropTypes.string,
};

export default function ClaimDataFormModal({ open, onClose, claim_id }) {
  const [isLoading, setIsLoading] = useState(false);
  const { setOpenCD, tca, setCDActions, setTca, CDActions } = ContentDialogInit();
  const [backendData] = useRecoilState(backendDataAtom);
  const { updateClaim } = useClaimActions();

  useEffect(() => {
    if(open){
      openForm();
    }
  }, [open]);

  // unset formdata from backendData
  const { formdata, ...claimData } = backendData?.data || {};

  const openForm = () => {
    setTca({
      title: "Schadendaten bearbeiten",
      maxWidth: "sm",
      content: (
        <>
          <Form>
            <FormRenderer
              fdef={getRWObjectCopy(fdefSchadenEdit)}
              model={claimData}
              variant="filled"
              editMode={true}
              showActions={false}
              showCancel={false}
              showToggleEdit={false}
              actionsPosition="bottom"
              toggleEditPosition="top"
              showErrorText={false}
              setActions={setCDActions}
              submitAction={{
                method: "callback",
                isLoading: isLoading, // funktioniert nicht wie erwartet
                callback: async (data) => {
                  await updateClaim(backendData.data.id, data, {
                    label: "Schadendaten aktualisieren",
                    setIsLoading: setIsLoading,
                  });
                  onClose();
                }
              }}
            />
          </Form>
        </>
      ),
      actions: null,
    });
  };

  return (
    <ContentDialog
      openCD={open}
      setOpenCD={setOpenCD}
      tca={tca}
      CDActions={CDActions}
      onClose={onClose}
    />
  );
}
